import React from 'react';
import styled from 'styled-components';

import { State } from '@store/index';
import { useSelector } from 'react-redux';

const Container = styled.div<{ size: number }>`
  position: relative;
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  transform: translateZ(0);
`;

const Svg = styled.svg<{ size: number }>`
  @keyframes fadeInOut {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.5;
      transform: scale(0.85);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  animation: fadeInOut 1.5s ease infinite;
  margin: 20%;
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
`;

const Circle = styled.div<{ isDarkBackground: boolean }>`
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border-radius: 50%;

  border-top: 2px solid ${({ theme, isDarkBackground }) => (isDarkBackground ? theme.telnyx.green : 'black')};
  animation: spin 1.5s infinite;
`;

export const LoadingContainer = styled.div`
  display: flex;
  padding-top: 2rem;
  justify-content: center;
`;

export const TelnyxLoader = ({ size = 60, isDarkBackground = false }) => {
  const svgSize = size * 0.6;

  return (
    <Container size={size}>
      <Circle isDarkBackground={isDarkBackground} />
      <Svg size={svgSize} viewBox='0 0 40 37' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_2875_21370)'>
          <path
            d='M15.4796 12.1439H9.41406L13.3742 4.69795C14.0102 3.49906 14.963 2.49538 16.1299 1.79495C17.2969 1.09452 18.6338 0.723872 19.9968 0.7229C21.3598 0.722813 22.697 1.09226 23.8646 1.7915C25.0322 2.49074 25.986 3.49331 26.6234 4.69138L30.5835 12.1374H24.5114L21.8792 7.18825C21.6975 6.84674 21.4256 6.56095 21.0928 6.36162C20.7599 6.16229 20.3787 6.05696 19.9902 6.05696C19.6017 6.05696 19.2205 6.16229 18.8877 6.36162C18.5549 6.56095 18.283 6.84674 18.1012 7.18825L15.4796 12.1439Z'
            fill='#00E3AA'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M19.9968 1.71101e-08C21.4904 -9.60972e-05 22.956 0.404744 24.236 1.17131C25.516 1.93789 26.5622 3.03734 27.2616 4.35182L31.7868 12.8603H24.077L21.241 7.52782C21.1212 7.3027 20.9417 7.11378 20.7213 6.98178C20.5009 6.84977 20.2481 6.77984 19.9902 6.77984C19.7323 6.77984 19.4795 6.84977 19.2591 6.98178C19.0389 7.11365 18.8595 7.30233 18.7398 7.52716C18.7396 7.52738 18.7399 7.52694 18.7398 7.52716L15.915 12.8668H8.21082L12.7356 4.35916C12.7357 4.35903 12.7355 4.3593 12.7356 4.35916C13.4334 3.04392 14.4786 1.94296 15.7579 1.17513C17.0372 0.40724 18.5031 0.0010648 19.9968 1.71101e-08ZM19.9973 1.44578C21.2295 1.44579 22.4381 1.77984 23.4932 2.41167ZM19.9973 1.44578C18.7651 1.4467 17.5564 1.78183 16.5019 2.41476C15.4474 3.0477 14.587 3.95436 14.0128 5.03671L10.6173 11.421H15.0442L17.4622 6.85021L17.4631 6.84868C17.7067 6.39077 18.071 6.0081 18.5163 5.74143C18.9615 5.47478 19.4711 5.33406 19.9902 5.33406C20.5094 5.33406 21.0189 5.47478 21.4642 5.74143C21.9094 6.0081 22.2737 6.39076 22.5174 6.84868L24.9457 11.4145H29.3803L25.9852 5.03092C25.4097 3.94926 24.5483 3.04357 23.4932 2.41167'
            fill='black'
          />
          <path
            d='M39.1213 28.5534C39.0281 28.1741 38.8953 27.8054 38.7253 27.4533C38.6725 27.3391 38.6144 27.2249 38.5524 27.1133L33.4201 17.4777H27.3611L32.933 27.9456C33.461 28.921 32.7759 30.1143 31.6974 30.1143H25.3612C25.3612 30.8147 25.2224 31.5083 24.9528 32.1553C24.6831 32.8024 24.2879 33.3903 23.7897 33.8854C23.2915 34.3805 22.7001 34.7731 22.0492 35.0408C21.3984 35.3084 20.7009 35.446 19.9966 35.4454H33.9639C34.756 35.4454 35.5242 35.1422 36.2384 34.7982C37.2255 34.3195 38.0393 33.5487 38.5682 32.5915C39.2535 31.3615 39.4508 29.9209 39.1213 28.5534Z'
            fill='#00E3AA'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M26.1574 16.7548H33.8541L39.1875 26.7679C39.2558 26.8913 39.3201 27.0175 39.3789 27.1443C39.5695 27.5401 39.7185 27.9545 39.8233 28.3809L39.8241 28.3841C40.1961 29.9278 39.9734 31.554 39.2003 32.9422C38.599 34.0299 37.6743 34.9052 36.5538 35.4487L36.552 35.4495C35.8217 35.8013 34.9287 36.1683 33.9639 36.1683H19.9966L19.9971 34.7225C19.9994 34.7225 20.0017 34.7225 20.004 34.7225C20.6115 34.7221 21.213 34.603 21.7743 34.3722C22.3376 34.1405 22.8493 33.8008 23.2802 33.3726C23.711 32.9445 24.0526 32.4363 24.2855 31.8773C24.5185 31.3182 24.6383 30.7192 24.6383 30.1143V29.3914H31.6974C32.194 29.3914 32.581 28.8139 32.2973 28.2898L32.2948 28.2853L26.1574 16.7548ZM23.9459 34.7225H33.9639C34.583 34.7225 35.2262 34.4833 35.9238 34.1474C36.7767 33.7335 37.4792 33.0677 37.9355 32.2419L37.9367 32.2396C38.5335 31.1686 38.7053 29.9146 38.4189 28.7244C38.3377 28.3945 38.2223 28.0739 38.0744 27.7677L38.0691 27.7567C38.0239 27.659 37.974 27.5608 37.9206 27.4646L37.9142 27.4532L32.9861 18.2005H28.5648L33.57 27.6039C34.3398 29.0302 33.3569 30.8372 31.6974 30.8372H26.0406C25.9744 31.3848 25.8332 31.9219 25.6201 32.4334C25.3137 33.1685 24.8648 33.8361 24.2993 34.3981C24.1857 34.511 24.0678 34.6192 23.9459 34.7225Z'
            fill='black'
          />
          <path
            d='M14.64 17.395C14.64 16.0023 15.1963 14.6667 16.1865 13.6819C17.1767 12.6972 18.5197 12.1439 19.9201 12.1439H6.57849V17.4777H14.64V17.395Z'
            fill='#00E3AA'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M5.85559 11.421H19.9201V12.8668C18.7102 12.8668 17.5506 13.3448 16.6962 14.1945C15.842 15.044 15.3629 16.1953 15.3629 17.395V18.2006H5.85559V11.421ZM16.0045 12.8668H7.30137V16.7548H13.9516C14.0978 15.4047 14.7031 14.1376 15.6767 13.1693C15.7825 13.0641 15.8919 12.9632 16.0045 12.8668Z'
            fill='black'
          />
          <path
            d='M19.9201 12.1439C18.5197 12.1439 17.1766 12.6972 16.1864 13.6819C15.1962 14.6667 14.6399 16.0023 14.6399 17.395V30.1196H17.3869C18.0827 30.113 18.7478 29.8335 19.2375 29.3418C19.7272 28.8501 20.0019 28.1861 20.0019 27.494V20.0953C20.0019 19.399 20.2801 18.7312 20.7752 18.2388C21.2703 17.7464 21.9418 17.4698 22.642 17.4698H33.4241V12.1439H19.9201Z'
            fill='#00E3AA'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M15.6768 13.1693C16.8029 12.0494 18.3293 11.421 19.9202 11.421H34.1471V18.1927H22.6421C22.1323 18.1927 21.6443 18.3941 21.285 18.7514C20.9259 19.1085 20.7249 19.592 20.7249 20.0953V27.494C20.7249 27.494 20.7249 27.494 20.7249 27.494C20.7249 28.3778 20.374 29.2252 19.7498 29.8519C19.1257 30.4785 18.2789 30.8341 17.3938 30.8424L17.387 30.8425L13.9171 30.8425V17.395C13.9171 15.8093 14.5506 14.2894 15.6768 13.1693ZM19.9202 12.8668C18.7102 12.8668 17.5506 13.3448 16.6963 14.1945C15.8421 15.044 15.3629 16.1953 15.3629 17.395V29.3967H17.3832C17.8887 29.3911 18.3709 29.1877 18.7254 28.8317C19.0806 28.4751 19.2791 27.9943 19.2791 27.4941V20.0953C19.2791 19.206 19.6344 18.3538 20.2655 17.7262C20.8965 17.0987 21.7515 16.7469 22.6421 16.7469H32.7013V12.8668H19.9202Z'
            fill='black'
          />
          <path
            d='M25.3627 17.4698H22.6368C21.9366 17.4698 21.2651 17.7465 20.77 18.2388C20.2749 18.7312 19.9967 19.399 19.9967 20.0954V27.498C19.9939 28.1925 19.7145 28.8577 19.2197 29.3478C18.7249 29.8379 18.055 30.1131 17.3566 30.1131H8.30777C7.22929 30.1131 6.54815 28.9198 7.07089 27.9444L12.6401 17.4698H6.57851L1.44619 27.1095C1.38415 27.221 1.32739 27.3353 1.27327 27.4495C0.886361 28.2576 0.698567 29.1457 0.725425 30.0404C0.752282 30.935 0.993024 31.8105 1.42772 32.5942C1.95774 33.5508 2.77254 34.3207 3.76023 34.7983C4.47437 35.1422 5.23999 35.4455 6.03598 35.4455H19.9967C21.4185 35.4455 22.782 34.8838 23.7873 33.884C24.7926 32.8843 25.3574 31.5283 25.3574 30.1144V17.4698H25.3627Z'
            fill='#00E3AA'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M6.14442 16.7469H13.8432L7.70916 28.2837L7.70804 28.2858C7.42469 28.8145 7.81474 29.3902 8.30776 29.3902H17.3566C17.8651 29.3902 18.352 29.1898 18.711 28.8342C19.0695 28.4791 19.2714 27.9982 19.2738 27.4968V20.0954C19.2738 19.206 19.6291 18.3539 20.2602 17.7263C20.8912 17.0988 21.7462 16.7469 22.6368 16.7469H25.3627V17.4698H26.0803V30.1144C26.0803 31.7213 25.4384 33.2616 24.297 34.3966C23.1558 35.5315 21.6089 36.1684 19.9967 36.1684H6.03597C5.0672 36.1684 4.17671 35.8013 3.44655 35.4496L3.44553 35.4491C2.32405 34.9068 1.39814 34.0322 0.795547 32.9448C0.304983 32.0603 0.0331728 31.0722 0.00284972 30.0621C-0.0274587 29.0525 0.184363 28.0503 0.620613 27.1386M6.14442 16.7469L0.81106 26.7642ZM24.6345 18.1927H22.6368C22.127 18.1927 21.639 18.3942 21.2797 18.7514C20.9206 19.1085 20.7196 19.592 20.7196 20.0954V27.498L20.7196 27.5009C20.716 28.388 20.3592 29.2366 19.7284 29.8614C19.0979 30.486 18.2449 30.836 17.3566 30.8359H8.30776C6.6443 30.8359 5.67215 29.026 6.43308 27.6041C6.43329 27.6037 6.43351 27.6033 6.43372 27.6029L11.4371 18.1927H7.01259L2.07809 27.4608C2.02651 27.5536 1.97705 27.6524 1.92652 27.759L1.92527 27.7616C1.58814 28.4658 1.42459 29.2395 1.44798 30.0187C1.47137 30.7979 1.68105 31.5605 2.05987 32.2435C2.51721 33.0689 3.22076 33.7343 4.07427 34.1472C4.77225 34.4833 5.41288 34.7226 6.03597 34.7226H19.9967C21.228 34.7226 22.4081 34.2361 23.2775 33.3715C24.1469 32.5069 24.6345 31.3353 24.6345 30.1144V18.1927Z'
            fill='black'
          />
        </g>
        <defs>
          <clipPath id='clip0_2875_21370'>
            <rect width='40' height='37' fill='white' />
          </clipPath>
        </defs>
      </Svg>
    </Container>
  );
};

export const Loader: React.FC = () => {
  const theme = useSelector((state: State) => state.flow.theme);
  return <TelnyxLoader size={50} isDarkBackground={theme === 'dark'} />;
};
